export default __webpack_public_path__ + "static/project-slide-5-1248-765-9c1112dc67485d26088241be1e4cc9a5.jpg";